import React from 'react';
import { SpotlightDirector } from '@amzn/ads-spotlight-assets';
import { useIsFeatureEnabled } from 'src/commons/hooks';
import { WeblabedFeatures } from 'src/commons/constants';

/**
 * Mounts the always-on SpotlightDirector orchestrator once, globally, behind the
 * ADS_SPOTLIGHT_LAUNCH_1466220 weblab (T1 = launch). The Director renders null and
 * drives spotlights via window CustomEvents + window.__SPOTLIGHT__, so it needs no
 * container or chrome context — only a single mount inside the always-rendered tree.
 */
export const SpotlightDirectorGate: React.FC = () => {
  const isSpotlightEnabled = useIsFeatureEnabled(
    WeblabedFeatures.ADS_SPOTLIGHT_LAUNCH,
  );

  return isSpotlightEnabled ? <SpotlightDirector /> : null;
};
